export default class Installations {
	constructor(element) {
		this.element = element;
		this.activeSlide = 0;
		this.slides = element.querySelectorAll(".installations__slide");
		this.labels = element.querySelectorAll(".installations__label");
		this.interval = setInterval(this.switchSlide.bind(this), 3000);

		this.init();
	}

	init() {
		this.activeSlide = -1;
		this.switchSlide();
		this.labels.forEach((el) => el.addEventListener("mouseover", (event) => {
			this.switchSlide(event);
		}));
		this.labels.forEach((el) => el.addEventListener("mouseout", () => {
			this.interval = setInterval(this.switchSlide.bind(this), 3000);
		}));
	}

	switchSlide(event) {
		// if index is specified
		if(event !== undefined) {
			for(let i = 0; i < this.labels.length; ++i) {
				if(this.labels[i] == event.currentTarget) this.activeSlide = i;
			}
			clearInterval(this.interval);
		}
		else {
			// increment and modulo
			this.activeSlide++;
			this.activeSlide %= this.slides.length;
		}

		this.slides.forEach((el) => el.classList.remove("active"));
		this.labels.forEach((el) => el.classList.remove("active"));
		this.slides[this.activeSlide].classList.add("active");
		this.labels[this.activeSlide].classList.add("active");
	}
}
